import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "perlla-construction-modal-seen";

export const UnderConstructionModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if user has already seen the modal in this session
    const hasSeenModal = sessionStorage.getItem(STORAGE_KEY);
    
    if (!hasSeenModal) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    // Mark modal as seen for this session
    sessionStorage.setItem(STORAGE_KEY, "true");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md border-primary/20 shadow-elegant">
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-2xl font-display text-center">
            We're Putting the Finishing Touches On...
          </DialogTitle>
          <DialogDescription className="text-base text-foreground/80 text-center leading-relaxed">
            Welcome to PERLLA! We are currently adding the final handcrafted 
            details to our marketplace before our official launch. Feel free to 
            explore, but please note that some features are still in testing. 
            We can't wait to share our full collection of Cypriot treasures 
            with you very soon.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-4">
          <Button
            onClick={handleClose}
            variant="aegean"
            size="lg"
            className="w-full sm:w-auto"
          >
            Explore the Preview
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
